$(document).ready(function() {
  
  setTimeout(function() {
    $('product-recommendations.related-products .product-grid').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      prevArrow: '<div class="slick-arrow prev-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.51923 13.1192C8.02691 12.6116 8.02691 11.7884 7.51923 11.2808L3.23847 7L7.51923 2.71924C8.02691 2.21156 8.02691 1.38844 7.51923 0.880762C7.01155 0.373079 6.18844 0.373079 5.68075 0.880762L0.480752 6.08076C-0.0269303 6.58844 -0.0269303 7.41156 0.480752 7.91924L5.68075 13.1192C6.18844 13.6269 7.01155 13.6269 7.51923 13.1192Z" fill="#1D7867"/></svg></div>',
      nextArrow: '<div class="slick-arrow next-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.480738 13.1192C-0.0269444 12.6116 -0.0269444 11.7884 0.480737 11.2808L4.7615 7L0.480737 2.71924C-0.0269449 2.21156 -0.0269449 1.38844 0.480737 0.880762C0.988419 0.373079 1.81153 0.373079 2.31922 0.880762L7.51922 6.08076C8.0269 6.58844 8.0269 7.41156 7.51922 7.91924L2.31922 13.1192C1.81153 13.6269 0.988419 13.6269 0.480738 13.1192Z" fill="#1D7867"/></svg></div>',
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

    $('product-recommendations-custom .product-grid').slick({
      dots: false,
      infinite: false,
      adeptiveHeight: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      prevArrow: '<div class="slick-arrow prev-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.51923 13.1192C8.02691 12.6116 8.02691 11.7884 7.51923 11.2808L3.23847 7L7.51923 2.71924C8.02691 2.21156 8.02691 1.38844 7.51923 0.880762C7.01155 0.373079 6.18844 0.373079 5.68075 0.880762L0.480752 6.08076C-0.0269303 6.58844 -0.0269303 7.41156 0.480752 7.91924L5.68075 13.1192C6.18844 13.6269 7.01155 13.6269 7.51923 13.1192Z" fill="#1D7867"/></svg></div>',
      nextArrow: '<div class="slick-arrow next-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.480738 13.1192C-0.0269444 12.6116 -0.0269444 11.7884 0.480737 11.2808L4.7615 7L0.480737 2.71924C-0.0269449 2.21156 -0.0269449 1.38844 0.480737 0.880762C0.988419 0.373079 1.81153 0.373079 2.31922 0.880762L7.51922 6.08076C8.0269 6.58844 8.0269 7.41156 7.51922 7.91924L2.31922 13.1192C1.81153 13.6269 0.988419 13.6269 0.480738 13.1192Z" fill="#1D7867"/></svg></div>',
    });
  }, 4000);

  setTimeout(function() {
    $('.recently-viewed,.recommend-products').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="slick-arrow prev-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.51923 13.1192C8.02691 12.6116 8.02691 11.7884 7.51923 11.2808L3.23847 7L7.51923 2.71924C8.02691 2.21156 8.02691 1.38844 7.51923 0.880762C7.01155 0.373079 6.18844 0.373079 5.68075 0.880762L0.480752 6.08076C-0.0269303 6.58844 -0.0269303 7.41156 0.480752 7.91924L5.68075 13.1192C6.18844 13.6269 7.01155 13.6269 7.51923 13.1192Z" fill="#1D7867"/></svg></div>',
      nextArrow: '<div class="slick-arrow next-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.480738 13.1192C-0.0269444 12.6116 -0.0269444 11.7884 0.480737 11.2808L4.7615 7L0.480737 2.71924C-0.0269449 2.21156 -0.0269449 1.38844 0.480737 0.880762C0.988419 0.373079 1.81153 0.373079 2.31922 0.880762L7.51922 6.08076C8.0269 6.58844 8.0269 7.41156 7.51922 7.91924L2.31922 13.1192C1.81153 13.6269 0.988419 13.6269 0.480738 13.1192Z" fill="#1D7867"/></svg></div>',
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }, 1000);

  // tabify collection product slider js
  var $tabi_slider = $('.collection-product-wrapper');
  $tabi_slider.slick({
    dots: false,
    infinite: false,
    speed: 300,
    rows: 3,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 482,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
  

  $('.tabify-button-wrapper button').click(function(){
    var tab_id = $(this).attr('data-tab');
  
    $('.tabify-button-wrapper button').removeClass('active-tab');
    $('.tabify-section-wrapper').removeClass('active-tab');
  
    $(this).addClass('active-tab');
    $("#"+tab_id).addClass('active-tab');
    $tabi_slider.slick('refresh');
  });
  // $(".tabify-button-wrapper").clone().appendTo(".tabify-section-wrapper");

  $('.cart-header-items, .cart__footer-wrapper').wrapAll('<div class="main-cart-items-wrapper default-container"></div>');


  // header linklist collection image show on hover
  $('.mega-menu__list--condensed .header-mega-menuLink').mouseover(function(){
    var data_menu_handle = $(this).attr('data-menu-handle');
    $('.nav-collection_image').removeClass('active-collection-image');
    $("#"+data_menu_handle).addClass('active-collection-image');
  });
  $('.mega-menu__list--condensed .header-mega-menuLink').mouseleave(function(){
    var data_menu_handle = $(this).attr('data-menu-handle');
    $('.nav-collection_image').removeClass('active-collection-image');
    $("#"+data_menu_handle).removeClass('active-collection-image');
  });


  // Event handlers for mouseover and mouseleave on the second-level items
  $('.mega-menu-contents').mouseover(function() {
    var data_menu_handle = $(this).attr('data-menu-handle');
    $('.nav-collection_image').removeClass('active-collection-image');
    $("#"+data_menu_handle).addClass('active-collection-image');
  }).mouseleave(function() {
    var data_menu_handle = $(this).attr('data-menu-handle');
    $('.nav-collection_image').removeClass('active-collection-image');
    $("#"+data_menu_handle).removeClass('active-collection-image');
  });
  
});

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// console.log(items);

items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    document.querySelector(".header.header").classList.add("menu-hover-active"); 
    document.querySelector("body").classList.add("body-bg-color");
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      document.querySelector(".header.header").classList.remove("menu-hover-active");
      document.querySelector("body").classList.remove("body-bg-color");
    });
  });

  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
    document.querySelector(".header.header").classList.remove("menu-hover-active");
    document.querySelector("body").classList.remove("body-bg-color");
  });
});

let top_items = document.querySelector(".header__inline-menu-wrapper").querySelectorAll("details");
// console.log(top_items);

top_items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    document.querySelector(".header.header").classList.add("menu-hover-active"); 
    document.querySelector("body").classList.add("body-bg-color");
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      document.querySelector(".header.header").classList.remove("menu-hover-active");
      document.querySelector("body").classList.remove("body-bg-color");
    });
  });

  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
    document.querySelector(".header.header").classList.remove("menu-hover-active");
    document.querySelector("body").classList.remove("body-bg-color");
  });
});


document.querySelectorAll('[js-details-hover-effect]').forEach(menu => {
  menu.addEventListener('mouseover', () => {
    document.body.classList.add('body-blur');
  });

  menu.addEventListener('mouseout', () => {
    document.body.classList.remove('body-blur');
  });
});